import {useEffect, useState} from "react"
import {Card, Col, Row} from "react-bootstrap";
import {UsePost, UsePut} from "../../hooks/http";
import {UseMessage} from "../../hooks/UseMessage";
import AudienceForm from "./AudienceForm";

const Edit = ({audience}) => {

    const [errors, setErrors] = useState()
    const [enterprises, setEnterprises] = useState()
    const [isLoading, setIsLoading] = useState(true)


    const GetEnterprises = async () => {
        return await UsePut(
            `/enterprises/get`,
            {data: {offset: 0}, toArray: true, propLabel: 'name'}
        )
    }


    useEffect(() => {
        GetEnterprises().then((response) => {
            setEnterprises(response)
            setIsLoading(false)
        })
    }, [])


    const handleUpdate = (PostData) => {
        setIsLoading(true)
        UsePost(
            `/audiences/upsert/${audience?._id?.$oid}`,
            {data: PostData}
        ).then((response) => {
            window.setTimeout(() => {
                if (response.code >= 200 && response.code <= 299) {
                    UseMessage('success', 'Audience has been successfully updated')
                } else {
                    setErrors(response.errors)
                }
                setIsLoading(false)
            }, 1500)
        })
    }


    return (
        <>
            <Card>
                <Row>
                    <Col>
                        <AudienceForm audience={audience} enterprises={enterprises} errors={errors} isReady={!isLoading} onSubmit={handleUpdate}/>
                    </Col>
                </Row>
            </Card>
        </>
    )
}

export default Edit